import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const StandardStyledImageContainer = styled("div")`
    overflow: hidden;
    width: 100%;
    position: relative;
    margin-bottom: 0.5rem;

    @media (max-width: ${breakpoints.values.lg - 0.02}px) {
        margin-bottom: 0.1875rem;
    }

    .product-swiper {
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
    }

    .swiper-wrapper {
        height: auto;
    }
`
export default StandardStyledImageContainer
